import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from '../../fetch.js';
import { baseUrl, customHeaders, thriweMarketPlaceUrl, alrajhiValetURL } from '../../../../Containers/Config/index.js';

import {
  VENDOR_BOOKINGS_DATA_ALRAJHI_ACCEPT,
  VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI_ACCEPT,
  VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_ACCEPT,
} from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* GetVendorBookingsAlrajhiAccept({ payload }) {
  let projectBaseURL = payload?.headers?.code === 'SCB_V1' ? thriweMarketPlaceUrl : alrajhiValetURL;

  try {
    const bookingId = payload?.urlParam?.bookingId;
    const response = yield call(apiCall, {
      url: `${projectBaseURL}/v3/vendor/accept-booking/${bookingId}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': payload?.headers?.code,
      },
      params: {
        // bookingTypeId: payload?.urlParam?.bookingTypeId,
        // pageIndex: payload?.urlParam?.pageIndex,
        // pageSize: Constant?.TABLE_PAGE_SIZE,
        // sortOn: payload?.urlParam?.sortOn,
        // ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({ type: VENDOR_BOOKINGS_DATA_SUCCESS_ALRAJHI_ACCEPT, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_ACCEPT, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: VENDOR_BOOKINGS_DATA_ERROR_ALRAJHI_ACCEPT, payload: error });
  }
}

export function* watchGetVendorBookingsAlrajhiAccept() {
  yield takeEvery(VENDOR_BOOKINGS_DATA_ALRAJHI_ACCEPT, GetVendorBookingsAlrajhiAccept);
}

function* vendorBookingsSagaAlrajhiAccept() {
  yield all([fork(watchGetVendorBookingsAlrajhiAccept)]);
}

export default vendorBookingsSagaAlrajhiAccept;
